import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Search24 = (props)=>/*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M16.2051 16.2051L22 22M18.3906 10.1953C18.3906 14.7214 14.7214 18.3906 10.1953 18.3906C5.66916 18.3906 2 14.7214 2 10.1953C2 5.66916 5.66916 2 10.1953 2C14.7214 2 18.3906 5.66916 18.3906 10.1953Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
